import { useMutation } from '@tanstack/react-query'
import { createPISPurchaseInvoicePayment } from '@query'
import { buildPISPurchaseInvoicePaymentPayload } from '@utils'

type PISPaymentOptions = {
  shortcutId?: number
  providerCode?: string
}

type UsePISPurchaseInvoicePaymentParams = {
  slug: string
  purchaseInvoiceId: number
  isReady: boolean
  fallbackErrorMessage: string
}

export const usePISPurchaseInvoicePayment = ({
  slug,
  purchaseInvoiceId,
  isReady,
  fallbackErrorMessage
}: UsePISPurchaseInvoicePaymentParams) => {
  const mutation = useMutation({
    mutationFn: async (options?: PISPaymentOptions) => {
      if (!isReady) {
        return Promise.reject({ data: { non_field_errors: fallbackErrorMessage } })
      }

      const payload = buildPISPurchaseInvoicePaymentPayload(options, window.location.href)
      return createPISPurchaseInvoicePayment({ slug, purchaseInvoiceId }, payload)
    },
    onSuccess: response => {
      if (response?.payment_url) {
        window.location.assign(response.payment_url)
      }
    }
  })

  return {
    createPayment: mutation.mutateAsync,
    isPending: mutation.isPending
  }
}
